import { createFileRoute } from '@tanstack/react-router'
import { ReportPage } from '../public/report'
import { reportSearchSchema } from '../public/report/models/types'

export const Route = createFileRoute('/report')({
  validateSearch: reportSearchSchema,
  component: ReportPage,
})
